import identity from 'transmute/identity';
// @ts-expect-error file is untyped
import { createAction } from 'flux-actions';
import { addAlert } from 'documents-lib/js/utils/addAlert';
import { DOCUMENTS_GDPR_SETTING_FETCH_SUCCEEDED, DOCUMENTS_GDPR_SETTING_FETCH_CHIRP_SUCCEEDED, DOCUMENTS_GDPR_SETTING_FETCH_FAILED, DOCUMENTS_GDPR_SETTING_UPDATE_SUCCEEDED } from 'documents-lib/js/constants/ActionTypes';
import * as DocumentsSettingsApi from 'documents-ui/api/DocumentsSettingsApi';
export const fetchDocumentGDPRSettingSucceeded = createAction(DOCUMENTS_GDPR_SETTING_FETCH_SUCCEEDED, identity);
export const fetchDocumentGDPRSettingCHIRPSucceeded = createAction(DOCUMENTS_GDPR_SETTING_FETCH_CHIRP_SUCCEEDED, payload => payload);
export const fetchDocumentGDPRSettingFailed = createAction(DOCUMENTS_GDPR_SETTING_FETCH_FAILED, identity);
export const updateDocumentGDPRSettingSucceeded = createAction(DOCUMENTS_GDPR_SETTING_UPDATE_SUCCEEDED, identity);
export const fetchDocumentGDPRSetting = deckId => dispatch => DocumentsSettingsApi.fetchGDPRSettings(deckId).then(gdprRecord => dispatch(fetchDocumentGDPRSettingSucceeded(gdprRecord)), () => dispatch(fetchDocumentGDPRSettingFailed()));
export const updateDocumentGDPRSetting = ({
  deckId,
  legalConsentEnabled
}) => dispatch => DocumentsSettingsApi.updateGDPRSetting({
  deckId,
  legalConsentEnabled
}).then(gdprRecord => dispatch(updateDocumentGDPRSettingSucceeded(gdprRecord)), () => addAlert('updateGDPRSetting', 'danger', {}));